import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { start as startCookieBannerExperiment } from "./cookie-banner";
import { experimentFlag as cookieBannerExperimentFlag } from "./cookie-banner.types";
export async function start() {
    const cookieBannerFlag = await ewe.experiments.getFlag(cookieBannerExperimentFlag);
    if (cookieBannerFlag === true) {
        startCookieBannerExperiment();
    }
}
